import { render, staticRenderFns } from "./DataTableBlockButton.vue?vue&type=template&id=0a4b41f8&"
import script from "./DataTableBlockButton.vue?vue&type=script&lang=js&"
export * from "./DataTableBlockButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports